var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_12806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7499 49.25V0.750145H1.25V49.25H49.7499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_12806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3606 31.765C18.3544 30.974 18.515 29.5168 17.7233 28.5268C16.9288 27.534 15.47 27.3736 14.479 28.1645L10.8222 31.0875C9.8284 31.8783 9.66795 33.3385 10.4595 34.3284C11.2512 35.3185 12.7129 35.4816 13.7039 34.688",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5888 38.2892C15.595 39.0829 15.4345 40.5403 16.2262 41.5302C17.0179 42.523 18.4794 42.6834 19.4705 41.8924L23.1273 38.9695C24.121 38.1786 24.2815 36.7185 23.4898 35.7285C22.6954 34.7386 21.2366 34.5754 20.2455 35.369",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4703 41.8922C18.4792 42.6831 18.316 44.1433 19.1103 45.1332C19.9021 46.1231 21.3609 46.2863 22.3546 45.4927L24.4003 43.8556C25.3913 43.0648 25.5547 41.6073 24.7629 40.6174C23.9686 39.6246 22.5097 39.4643 21.5187 40.2551",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6812 32.6012L37.2944 34.6891C38.2853 35.4827 38.4487 36.9401 37.657 37.9301C36.8625 38.92 35.4036 39.0832 34.4127 38.2896L31.5781 36.0275",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.578 36.0272L34.4126 38.2892C35.4036 39.0829 35.567 40.5403 34.7724 41.5303C33.9807 42.523 32.5192 42.6833 31.5281 41.8925L28.6963 39.6277",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6966 39.6269L30.1111 40.7579C31.1021 41.5515 31.2655 43.009 30.4737 43.999C29.6793 44.9918 28.2205 45.1521 27.2295 44.3612L25.1699 42.7158",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.639 23.5019L49.3359 26.4995C49.729 27.1964 49.4826 28.0951 48.7823 28.4823L46.1664 29.9313C45.466 30.3185 44.5746 30.0752 44.1816 29.381L36.641 16.0438C36.2452 15.3468 36.4916 14.4508 37.1919 14.0638L39.8106 12.6147C40.5109 12.2276 41.3995 12.4682 41.7927 13.165L43.3234 15.8696",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9941 30.9395C40.6114 29.6066 41.9568 28.6193 43.5015 28.1769",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2947 34.688C38.2856 35.4816 39.7472 35.3185 40.539 34.3284C41.3333 33.3386 41.1701 31.8783 40.179 31.0875L37.0095 28.5544C35.4703 27.3266 33.732 25.9661 32.0822 24.7825C29.098 22.6449 27.6282 21.2235 23.8883 21.9756C21.062 22.5454 18.7755 21.6825 18.1804 19.2352C17.7983 17.6617 19.1381 16.9289 21.7928 16.6938L26.0282 16.3149C26.8641 16.2403 27.3624 16.163 28.716 16.6358L31.271 17.529C32.9984 18.1318 32.7659 18.2921 34.5623 17.7723L37.1867 17.0119",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8067 14.0638L11.1908 12.6147C10.4905 12.2276 9.59906 12.4682 9.20599 13.1651L1.66549 26.4996C1.26959 27.1965 1.51607 28.0952 2.21627 28.4823L4.83228 29.9313C5.53257 30.3185 6.42397 30.0752 6.81704 29.3811L14.3576 16.0438C14.7533 15.3469 14.5071 14.4509 13.8067 14.0638Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1884 18.2656L13.8174 16.9991",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0081 30.9395C10.388 29.6066 9.04267 28.6193 7.49805 28.1769",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.499 8.97852V4.00373",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.983 11.0391L16.3809 6.91046",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0186 11.0391L34.6179 6.91046",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7046 34.6891L18.9724 30.4802C19.9635 29.6894 21.4251 29.8525 22.2168 30.8424C23.0085 31.8324 22.8479 33.2899 21.8542 34.0835L16.589 38.2896C15.5953 39.0832 14.1365 38.92 13.3447 37.9301C12.5503 36.9401 12.7137 35.4827 13.7046 34.6891Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4775 19.6895V19.6856",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/partnership.e729e360e1df4d6e4d663cf4b5402e06.svg";
export { ForwardRef as ReactComponent };